import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=9afe68f8&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9afe68f8')) {
      api.createRecord('9afe68f8', component.options)
    } else {
      api.reload('9afe68f8', component.options)
    }
    module.hot.accept("./Preview.vue?vue&type=template&id=9afe68f8&", function () {
      api.rerender('9afe68f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/Preview.vue"
export default component.exports